import React from 'react';
import { Location } from 'history';
import queryString from 'query-string';
import { useNavigate } from 'react-router-dom';
import UnsavedChangesContext from 'context/UnsavedChangesContext';
import { UnsavedChangesProvider } from 'providers';
import { UnsavedChangesWrapperProps } from './types';
import UnsavedChangesGuard from './UnsavedChangesGuard';
import { withRouter, WithRouterProps } from '../../services/hooks/with-router/withRouter';

type UnsavedChangesWrapperPropsWithRouter = UnsavedChangesWrapperProps & WithRouterProps;

const UnsavedChangesWrapper = ({ children }: UnsavedChangesWrapperPropsWithRouter) => {
  const navigate = useNavigate();

  const handleNextAction = (targetLocation: Location): void => {
    const { pathname, search } = targetLocation;
    const parsedQuery = queryString.parse(search);
    if (parsedQuery.date) {
      delete parsedQuery.version;
    }
    const navigationTarget = { pathname, search: queryString.stringify(parsedQuery) };
    navigate(navigationTarget);
  };

  return (
    <UnsavedChangesProvider>
      <>
        <UnsavedChangesContext.Consumer>
          {({ action, isVisible, showDialog }) => {
            // Always render the guard when there are unsaved changes
            // This ensures the useBlocker hook is active to catch navigation attempts
            if (action) {
              return (
                <UnsavedChangesGuard
                  when={!!action}
                  next={handleNextAction}
                  shouldBlockNavigation={() => !!action}
                  showDialog={showDialog}
                  isVisible={isVisible}
                />
              );
            }
            return null;
          }}
        </UnsavedChangesContext.Consumer>
        {children}
      </>
    </UnsavedChangesProvider>
  );
};

export default withRouter(UnsavedChangesWrapper);
